import { BundleState } from './state';
import {
    ADD_BUNDLE_TO_CART,
    ADD_BUNDLE_TO_CART_FINISHED,
    ADD_BUNDLE_TO_LIST,
    ADD_BUNDLE_TO_LIST_FINISHED,
    BUNDLE_FAILURE,
    BUNDLE_REQUEST,
    BUNDLE_SUCCESS,
    BundleAction
} from './types';

const initialBundleState = { productAmount: 0, productStockAmount: 0, loading: false } as BundleState;

export function bundleReducer(bundle: BundleState = initialBundleState, action: BundleAction): Partial<BundleState> {
    switch (action.type) {
        case ADD_BUNDLE_TO_CART:
            return { ...bundle, productToCartAnimation: true };

        case ADD_BUNDLE_TO_CART_FINISHED:
            return { ...bundle, productToCartAnimation: false };

        case ADD_BUNDLE_TO_LIST:
            return { ...bundle, productToSelectionListAnimation: true };

        case ADD_BUNDLE_TO_LIST_FINISHED:
            return { ...bundle, productToSelectionListAnimation: false };

        case BUNDLE_REQUEST:
            return { loading: true, active: { id: action.payload as string } };

        case BUNDLE_SUCCESS:
            return { ...bundle, ...action.payload, loading: false };

        case BUNDLE_FAILURE:
            return {
                ...bundle,
                ...action.payload,
                error: action.error,
                loading: false
            };

        default:
            return bundle;
    }
}
